import React, { Component } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalTokens: 0,
      soldTokens: 0,
      unsoldTokens: 0,
      salePercentage: 0,
      currentStageTitle: '', // Add a state for the current stage title
      error: '',
    };
  }

  componentDidMount() {
    this.fetchStageData();
  }

  fetchStageData = async () => {
    try {
      const token = localStorage.getItem('token'); // Get token from localStorage

      const response = await fetch(`${process.env.REACT_APP_API_URL}/stages`, {
        headers: {
          'Authorization': `Bearer ${token}`, // Add Authorization header
          'Content-Type': 'application/json',
        }
      });

      if (response.status === 401 || response.status === 403) {
        localStorage.removeItem('token');
        window.location.href = '/login';
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      let currentStage = null;
      if (data.tokenomics && data.tokenomics.length > 0) {
        currentStage = data.tokenomics.find(item => item.isCurrent === true) || data.tokenomics[0];
      } else if (data.stages && data.stages.length > 0) {
        const currentDate = new Date();
        currentStage = data.stages.find(stage => {
          const startDate = new Date(stage.start_date);
          const endDate = new Date(stage.end_date);
          return currentDate >= startDate && currentDate <= endDate;
        }) || data.stages[0];
      }

      if (!currentStage) {
        this.setState({ error: 'No stage data found' });
        return;
      }

      const totalTokens = Number(currentStage.tokensToSell ?? currentStage.total_tokens ?? 0);
      const soldTokens = Number(currentStage.tokensSold ?? 0);
      const unsoldTokens = Math.max(totalTokens - soldTokens, 0);
      const salePercentage = totalTokens > 0 ? (soldTokens / totalTokens) * 100 : 0;

      this.setState({
        totalTokens,
        soldTokens,
        unsoldTokens,
        salePercentage,
        currentStageTitle: currentStage.stage ? `Stage ${currentStage.stage}` : currentStage.title,
        error: '',
      });
    } catch (error) {
      console.error('Error fetching stages data:', error);
      this.setState({ error: 'Unable to load stage data' });
    }
  };

  render() {
    const { totalTokens, soldTokens, unsoldTokens, salePercentage, currentStageTitle, error } = this.state;
    const formatNumber = (value) => Number(value || 0).toLocaleString();
    const options = {
      animationEnabled: true,
      theme: "dark1",
      backgroundColor: "transparent",
      subtitles: [{
        text: `${formatNumber(totalTokens)}`,
        verticalAlign: "center",
        fontSize: 24,
        dockInsidePlotArea: true,
        fontColor: "#fff",
      }],
      data: [{
        type: "doughnut",
        innerRadius: "70%", // Increase the innerRadius to make the hole larger
        radius: "90%",     // Increase radius to make the outer edge thicker
        showInLegend: true,
        indexLabel: "{name}: {y}",
        yValueFormatString: "#,###",
        indexLabelFontColor: "#fff",
        indexLabelLineColor: "#fff",
        lineThickness: 2,
        shadow: true,
        shadowColor: "#000",
        shadowBlur: 10,
        dataPoints: [
          { name: "Sold", y: soldTokens, color: "#32CD32" },
          { name: "Unsold", y: unsoldTokens, color: "#A9A9A9" },
        ],
        animationDuration: 1500,
        animationEasing: "easeOutBounce",
      }],
      legend: {
        cursor: "pointer",
        itemclick: function(e) {
          if (typeof(e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
            e.dataSeries.visible = false;
          } else {
            e.dataSeries.visible = true;
          }
          e.chart.render();
        },
        itemFontColor: "#fff",
        itemHoverStyle: { fontColor: "#FF6347" },
        itemFontSize: 16,
      },
      plotAreaBorderColor: "#333",
      borderColor: "#333",
      borderThickness: 2,
      toolTip: {
        shared: true,
        backgroundColor: "#222",
        contentFormatter: function(e) {
          return `${e.entries[0].dataPoint.name}: ${Number(e.entries[0].dataPoint.y || 0).toLocaleString()}`;
        },
      },
      padding: {
        top: 10,
        right: 10,
        bottom: 10,
        left: 10,
      },
    };

    return (
      <div style={{
        padding: '30px', 
        backgroundColor: 'black',
        borderRadius: '15px',
        boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.6)',
      }}>
        <h1 style={{
          width: '100%',
          color: '#fff',
          fontSize: '30px',
          fontWeight: 'bold',
          paddingBottom: '20px',
        }}>
          {currentStageTitle || 'Loading...'} {/* Display current stage title */}
        </h1>
        {error && (
          <p style={{ color: '#FF6347', fontWeight: 'bold' }}>{error}</p>
        )}
        <CanvasJSChart options={options} />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
            gap: '12px',
            marginTop: '20px',
            color: '#fff',
          }}
        >
          <div>
            <strong style={{ color: '#FF6347' }}>Total</strong>
            <br />
            {formatNumber(totalTokens)}
          </div>
          <div>
            <strong style={{ color: '#32CD32' }}>Sold</strong>
            <br />
            {formatNumber(soldTokens)}
          </div>
          <div>
            <strong style={{ color: '#A9A9A9' }}>Unsold</strong>
            <br />
            {formatNumber(unsoldTokens)}
          </div>
          <div>
            <strong style={{ color: '#FFD700' }}>Sale</strong>
            <br />
            {salePercentage.toFixed(2)}%
          </div>
        </div>
      </div>
    );
  }
}

export default App;
